import { initialState } from "./state"

export default {
  setListOffersSeparate: (state, payload) =>
    (state.listOffersSeparate = payload),
  setOptionsOffersSeparate: (state, payload) =>
    (state.optionsOffersSeparate = payload),
  setPaginationOffersSeparate: (state, payload) =>
    (state.paginationOffersSeparate = payload),

  resetOffersSeparate: state => {
    const init_state = initialState()
    Object.assign(state, init_state)
  },
  setCurrentPage: (state, payload) => (state.currentPage = payload),
  setSeparateFilter: (state, payload) => (state.separateFilter = payload),
  setSeparateFilterToInitial: state =>
    (state.separateFilter = initialState().separateFilter)
}
